import { type IncludedFinalGrade } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";

import { type useGetContractorBadgeVerification } from "../api/useGetContractorBadgeVerification";

/**
 * Extracts the IncludedFinalGrade from a contractor badge verification response
 * by matching the finalGrade relationship to the included resources.
 *
 * Takes `data[0]` because the query filters by shiftId — there is at most one
 * verification per shift.
 */
export function extractGradeFromVerificationData(
  data: ReturnType<typeof useGetContractorBadgeVerification>["data"]
): IncludedFinalGrade | undefined {
  const verification = data?.data[0];
  if (!isDefined(verification)) {
    return undefined;
  }

  const gradeId = verification.relationships.finalGrade?.data?.id;
  if (!isDefined(gradeId)) {
    return undefined;
  }

  return data?.included?.find(
    (resource): resource is IncludedFinalGrade =>
      resource.type === "contractor-badge-verification-grade" && resource.id === gradeId
  );
}
